// extracted by mini-css-extract-plugin
module.exports = {"panel-content":"SettingsPanel-module__panel-content___3-sHY","settings-sub-panel":"SettingsPanel-module__settings-sub-panel___2CqvQ"};